import { Injectable } from '@angular/core';

const APP_BUILDER_CHANGES_STATUS = 'app_builder_changes_status';
@Injectable({
  providedIn: 'root',
})
export class AppBuilderChangesStatusService {
  private _appBuilderStatus: any;
  get appBuilderStatus() {
    this._appBuilderStatus = sessionStorage.getItem(APP_BUILDER_CHANGES_STATUS);
    return this._appBuilderStatus;
  }

  set appBuilderStatus(value: string) {
    sessionStorage.setItem(APP_BUILDER_CHANGES_STATUS, value);
  }
}
